import store from '../../store.js';

export default {
    getPlaPublicationManifestVersion() {
        return store.state.plaPublicationManifestVersion;
    },
    getEncryptionKeyIvSeed() {
        return store.state.contentEncryption.ivSeed;
    },
    versionSupportsEncryption() {
        return this.getPlaPublicationManifestVersion().split('.').map(Number)[0] >= 2;
    },
    shouldDecryptFile(targetUrl) {
        if (!this.versionSupportsEncryption()) {
            return false;
        }
        return (
            targetUrl.endsWith('html') ||
            targetUrl.endsWith('htm') ||
            targetUrl.endsWith('css') ||
            targetUrl.endsWith('xml')
            // || targetUrl.endsWith('png')
            // || targetUrl.endsWith('jpg')
        );
    },
    shouldDecrypt() {
        return this.versionSupportsEncryption();
    },
    shouldEncrypt() {
        return this.versionSupportsEncryption();
    },
};
